import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import silande from '../assets/Footer/silandeLogo.png';
import './Navbar.css';

function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const handleNavigation = (id) => {
        if (location.pathname !== "/") {
            navigate("/");
        }
        setTimeout(() => {
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }, 100);
    };

    const handleLogoClick = () => {
        navigate("/");
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleLinkClick = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (menuOpen) setMenuOpen(false); // Cierra el menú en mobile
    };

    return (
        <nav className="navbar">
            <div className="navbar-left">
                <img
                    src={silande}
                    alt="Logo"
                    className="logo"
                    onClick={handleLogoClick}
                    style={{ cursor: "pointer" }}
                />
            </div>

            {/* DESKTOP MENU */}
            <div className="navbar-center desktop-menu">
                <ul>
                    <li><button className="nav-button" onClick={() => handleNavigation("approach")}>Inicio</button></li>
                    <li className='line'>|</li>
                    <li><Link to="/nosotros" onClick={handleLinkClick}>Nosotros</Link></li>
                    <li className='line'>|</li>
                    <li><Link to="/productos" onClick={handleLinkClick}>Productos</Link></li>
                    <li className='line'>|</li>
                    <li><Link to="/industrias" onClick={handleLinkClick}>Industrias</Link></li>
                </ul>
            </div>

            {/* MOBILE MENU */}
            {menuOpen && (
                <div className="responsive-menu">
                    <ul>
                        <li><button className="nav-button" onClick={() => handleNavigation("approach")}>Inicio</button></li>
                        <li><Link to="/nosotros" onClick={handleLinkClick}>Nosotros</Link></li>
                        <li><Link to="/productos" onClick={handleLinkClick}>Productos</Link></li>
                        <li><Link to="/industrias" onClick={handleLinkClick}>Industrias</Link></li>
                        <li><a href="#footer" onClick={() => setMenuOpen(false)}>Contacto</a></li>
                    </ul>
                </div>
            )}

            <div className="navbar-right">
                <p className="contact-button">
                    <a href="#footer" style={{ textDecoration: "none", color: "white" }}>
                        Contacto
                    </a>
                </p>
            </div>

            <div className="menu-icon" onClick={toggleMenu}>
                {menuOpen ? (
                    <div className="close-btn">X</div>
                ) : (
                    <>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                    </>
                )}
            </div>
        </nav>
    );
}

export default Navbar;
